// extracted by mini-css-extract-plugin
export default {"FormHolder":"AddFactorContainer_FormHolder__xX3pB","SearchNumberHolder":"AddFactorContainer_SearchNumberHolder__t8xZt"};